import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
var fullWidthStyles = css(["margin-bottom:24px;", ";"], minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
export var Side = styled.div.withConfig({
  displayName: "Side",
  componentId: "sc-84itt-0"
})(["width:100%;min-width:", "px;max-width:", "px;", ";margin-left:", ";", ";"], grid(2), grid(3), function (_ref) {
  var padding = _ref.padding;
  return padding ? 'padding-top: 10px;' : null;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.columnGap, "px");
}, maxMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n\n    max-width: ", ";\n\n    ", ";\n    margin: 0 auto;\n\n    ", ";\n  "])), function (_ref3) {
  var noViewMobile = _ref3.noViewMobile;
  return noViewMobile ? 'display:none;' : null;
}, function (_ref4) {
  var fullWidth = _ref4.fullWidth;
  return fullWidth ? '100%' : "".concat(grid(5), "px");
}, function (_ref5) {
  var padding = _ref5.padding;
  return padding ? 'padding-top: 0;' : null;
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth ? fullWidthStyles : null;
}));